<div class="account-form-wrapper">
  <div class="signup-form" *ngIf="mfaPageActive">
    <app-mfa-authenticator (emitEvent)="mfaValidationStatus($event)"></app-mfa-authenticator>
  </div>
  <form
    *ngIf="!mfaPageActive && signinForm && !startRegistraionShowNIC && !showSocialLoginRegistration && !showSignupForm"
    class="form user-login-form user-form" #form="ngForm" [formGroup]="signinForm" (ngSubmit)="onSignin(form)"
    novalidate>
    <div class="row">
      <div class="col inner-fields">
        <h1 class="signin-title">{{ translate.currentLang === 'en' ? 'Welcome Back to CAL Bangladesh' : 'CAL বাংলাদেশে
          ফিরে আসার জন্য স্বাগতম' }}</h1>

        <p class="signin-detail">{{ translate.currentLang === 'en' ? 'Access your investment portfolio anytime,
          anywhere.' : 'যেকোনো সময়, যেকোনো জায়গা থেকে আপনার বিনিয়োগ পোর্টফোলিও অ্যাক্সেস করুন।' }}</p>

        <div class="segmented-toggle">
          <div class="segment" [class.active]="selected === 'login'" (click)="selected = 'login'">
            {{ translate.currentLang === 'en' ? 'Login' : 'লগইন' }}
          </div>

          <div class="segment" [class.active]="selected === 'signup'" (click)="registrationProcess()">
            {{ translate.currentLang === 'en' ? 'Become an Investor' : 'একজন বিনিয়োগকারী হন' }}
          </div>
        </div>

        <div class="item-fields">
          <div class="form-group">
            <input formControlName="username" type="email" inputmode="email" autocomplete="username"
              autocapitalize="off" spellcheck="false"
              class="form-control us" id="username" (keypress)="restrictUN($event)"
              (paste)="onPaste($event)"
              [placeholder]="translate.currentLang === 'en' ? 'Enter your registered email' : 'আপনার নিবন্ধিত ইমেইল লিখুন'"
              maxlength="40" />
            <!--            placeholder="{{'login.username_placeholder' | translate}}"-->
            <!--error msg-->
            <div [hidden]="signinForm.controls['username'].valid || !form.submitted" class="alert alert-danger">
              <span [hidden]="!signinForm.controls.username.errors?.required">{{ 'login.username_required_msg' |
                translate }}</span>
            </div>
          </div>
          <div class="form-group mb-2 position-relative">
            <input formControlName="password" type="{{ (changePWType && 'text') || 'password' }}" autocapitalize="off"
              spellcheck="false" autocomplete="current-password" class="form-control" id="password"
              [placeholder]="translate.currentLang === 'en' ? 'Enter your password' : 'আপনার পাসওয়ার্ড লিখুন'" />
            <span class="float-end show-password">
              <button id="btn-view" aria-label="password-preview" type="button" (click)="displayPassword()">
                <i class="fa fa-eye"></i>
              </button>
            </span>
          </div>
          <div class="row">
            <div class="col-12 d-flex justify-content-between align-items-center">
              <label class="remember-me-checkbox">
                <input type="checkbox" formControlName="rememberMe" />
                <span>{{ translate.currentLang === 'en' ? 'Remember me' : 'আমাকে মনে রাখুন' }}</span>
              </label>
              <a class="forgot-pw" routerLink="/forgot-password">{{ translate.currentLang === 'en' ? 'Forgot Password?'
                : 'পাসওয়ার্ড ভুলে গেছেন?' }}</a>
            </div>
            <!--error msg-->
            <div class="col-12">
              <div [hidden]="signinForm.controls['password'].valid || !form.submitted" class="alert alert-danger">
                <span [hidden]="!signinForm.controls.password.errors?.required">{{ 'login.password_required_msg' |
                  translate }}</span>
                <span [hidden]="!signinForm.controls.password.errors?.password">{{ 'login.password_error_msg' |
                  translate }}</span>
              </div>
            </div>
          </div>
          <div class="form-group m-t m-b-sm" [hidden]="!enableCaptcha">
            <div class="recaptchaSlide" [slide]="showRecaptcha">
              <custom-captcha [control]="signinForm.get('captchaText')"
                placeholder="{{ 'login.captcha_placeholder' | translate }}"
                label="{{ 'login.captcha_label' | translate }}" [showErrors]="form.submitted"
                (captchaRequest)="captchaRequest($event)" [resetOnError]="resetOnError">
                <span [hidden]="!signinForm.get('captchaText').errors?.required">{{ 'login.captcha' | translate
                  }}</span>
              </custom-captcha>
            </div>
          </div>
          <div class="row button-row">

            <app-primary-button id="btn-l-1"
              [text]="translate.currentLang === 'en' ? 'Sign In Securely' : 'সুরক্ষিতভাবে সাইন ইন করুন'"
              [loading]="siginingInProgress" type="submit" [fullWidth]="true">
            </app-primary-button>
            <p class="signin-detail-2">{{ translate.currentLang === 'en' ? 'Your login is protected with industry-grade
              encryption.' : 'আপনার লগইন শিল্প-গ্রেড এনক্রিপশন দিয়ে সুরক্ষিত।' }}</p>
            <app-help-box></app-help-box>
          </div>


          <errors style="position: relative; top: 10px" [on]="signinFormErrors">
            <span [innerHTML]="signinFormErrors"></span>
          </errors>
        </div>
      </div>
    </div>
  </form>

  <div class="user-registraion form" *ngIf="showSignupForm">
    <app-sign-up [enteredFields]="registrationForm?.value" [socialLoginUserDetails]="socialUser"
      (changeNIC)="changeNIC($event)" (backToLogin)="backToLogin($event)"
      (verificationSent)="verificationSent = $event"></app-sign-up>
  </div>
  <p class="signin-detail-2" *ngIf="!verificationSent">{{ translate.currentLang === 'en' ? 'If you\'re unable to
    complete this process online, please visit our nearest CAL branch for assistance.' : 'যদি আপনি অনলাইনে এই
    প্রক্রিয়াটি সম্পূর্ণ করতে অক্ষম হন, অনুগ্রহ করে সহায়তার জন্য আমাদের নিকটতম CAL শাখায় যান।' }}</p>
  <div class="powered-by text-center">
    <div>
      {{ translate.currentLang === 'en' ? 'Powered by' : 'পাওয়ার্ড বাই' }}
      <a href="https://calbd.com.bd" target="_blank">CAL</a> | <a href="/terms-and-conditions">{{ translate.currentLang
        === 'en' ? 'Disclaimer' : 'দাবিত্যাগ' }}</a>
    </div>
  </div>
</div>